import { render, staticRenderFns } from "./M12.vue?vue&type=template&id=f18a353c&scoped=true"
import script from "./M12.vue?vue&type=script&lang=js"
export * from "./M12.vue?vue&type=script&lang=js"
import style0 from "./M12.vue?vue&type=style&index=0&id=f18a353c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18a353c",
  null
  
)

export default component.exports